module.exports = __webpack_public_path__ + "assets/img/11.d6debfdc.jpg";